import isomorphicUnfetch from 'isomorphic-unfetch';
import { fetchOpts, baseUrlOf } from '../../lib/ssr';

const {
  abortableFetch
} = require('abortcontroller-polyfill/dist/cjs-ponyfill');
const { fetch } = abortableFetch({
  fetch: isomorphicUnfetch,
  Request: isomorphicUnfetch.Request
});
const QUOTES_RESOURCE = '/api/quotes';
const get = (req, res, controller = undefined) => {
  const baseUrl = baseUrlOf(req);
  const opts = fetchOpts(req, res);
  return fetch(`${baseUrl}${QUOTES_RESOURCE}`, {
    headers: {
      ...opts.headers,
      Accept: 'application/json'
    },
    signal: controller ? controller.signal : undefined
  }).then(res => res.json());
};
const createQuote = async (travel, beneficiaries, controller = undefined) => {
  const result = await fetch(QUOTES_RESOURCE, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ stay: travel, beneficiaries: beneficiaries }),
    signal: controller ? controller.signal : undefined
  });
  return await result.json();
};

const updateSteps = async (id, steps, controller = undefined) => {
  const body = JSON.stringify(steps);
  await fetch(`${QUOTES_RESOURCE}/${id}/steps`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body,
    signal: controller ? controller.signal : undefined
  }).then(res => res.json());
};

const updateBeneficiaries = async (
  id,
  beneficiaries,
  controller = undefined
) => {
  const body = JSON.stringify(beneficiaries);
  await fetch(`${QUOTES_RESOURCE}/${id}/beneficiaries`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body,
    signal: controller ? controller.signal : undefined
  }).then(res => res.json());
};

const quotes = {
  createQuote: createQuote,
  updateSteps: updateSteps,
  updateBeneficiaries: updateBeneficiaries,
  get: get
};
export default quotes;
